import React from "react"
import {Button, Dropdown} from "antd"
import {EditOutlined} from "@ant-design/icons"
import GroupBuyingBaseForm from "./component/GroupBuyingEditBase"
import GroupBuyingGiftForm from "./component/GroupBuyingEditGift"
import GroupBuyingEditTable from "./component/GroupBuyingEditTable"
import GroupBuyingEditRelation from "./component/GroupBuyingEditRelation"
import PlatformCode from "../../../ClubPlatform/common/ClubPlatformContanst"

const GroupBuyingEdit = ({record}) => {
    const items = [
        {
            key: '1',
            label: <GroupBuyingBaseForm groupon={record.groupon} limitTime={record.limitTime}/>
        },
        {
            key: '2',
            label: <GroupBuyingGiftForm gifts={record.gifts} grouponId={record.groupon.id}/>
        },
        {
            key: '3',
            label: <GroupBuyingEditTable enabledTables={record.enabledTables}
                                         isEnabledOnAllTables={record.groupon.isEnabledOnAllTables}
                                         grouponId={record.groupon.id}/>
        },
        {
            key: '4',
            label: <GroupBuyingEditRelation groupon={record} platformCode={PlatformCode.MeiTuan}
                                            platformName={"美团/大众点评"}/>
        },
        {
            key: '5',
            label: <GroupBuyingEditRelation groupon={record} platformCode={PlatformCode.DouYin} platformName={"抖音"}/>
        }
    ]


    return (
        <div>
            <Dropdown
                menu={{items}}
                arrow={true}
            >
                <Button
                    type={"primary"}
                    icon={<EditOutlined/>}
                >
                    编辑
                </Button>
            </Dropdown>
        </div>
    )
}

export default GroupBuyingEdit


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingEdit/GroupBuyingEdit.js